"use strict";

exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-overlays/~/dom-helpers/util/hyphenate.js
 ** module id = ./node_modules/react-overlays/node_modules/dom-helpers/util/hyphenate.js
 ** module chunks = 0
 **/